import { Box, BoxProps } from "@chakra-ui/react";
import { FiInfo } from "react-icons/fi";

export const InfoIcon = (props: BoxProps) => {
  return <Box as={FiInfo} height="20px" width="20px" {...props} />;
};
